// eslint-disable-next-line no-unused-vars
import React from 'react';
import { oneOf } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { NWLabel } from 'Components/shared';

const STATUS_KEYS = {
  expired: 'offers.expiredStatus',
  valid: 'offers.validStatus',
  saved: 'offers.savedStatus',
  private: 'offers.privateStatus'
};

const OfferStatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const expired = status === 'expired';

  return (
    <NWLabel variant={ expired ? 'danger' : 'success' }>
      { t(STATUS_KEYS[status] || 'offers.privateStatus') }
    </NWLabel>
  );
};

OfferStatusBadge.propTypes = {
  status: oneOf(['expired', 'valid', 'saved', 'private'])
};

export default OfferStatusBadge;
